import React, { useState } from 'react';
import { connect } from 'react-redux';
import { NotificationBar } from 'react-lib/dist/components-es';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { initSelectors } from '../../behavior/init';
import { competenciesActions } from '../../behavior/competencies';
import { useOnce } from 'react-lib/dist/hooks-es';
import useUser from '@behavior/init/getUserV2';

const CompetencyToExpireNotificationBarComponent = ({
  getRequiredCompetencies,
  requiredCompetencies,
  t,
}) => {
  const { user } = useUser();
  const [isNotificationBarShown, updateIsNotificationBarShown] = useState(true);

  useOnce(() => {
    if (!initSelectors.isPublic(user)) getRequiredCompetencies();
  });

  return (
    <>
      {requiredCompetencies &&
          requiredCompetencies.find(c => c.isAboutToExpire) &&
        isNotificationBarShown && (
          <NotificationBar
            notificationText={t('required.competency.is.about.to.expire.notification.bar.message')}
            updateIsNotificationBarShown={updateIsNotificationBarShown}
          />
        )}
    </>
  );
};

const mapStateToProps = state => ({
  ...state.competencies,
});

const mapDispatchToProps = dispatch => ({
  getRequiredCompetencies: () => dispatch(competenciesActions.getRequiredCompetencies()),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withTranslation()
)(CompetencyToExpireNotificationBarComponent);
